import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const config = {
  apiKey: 'AIzaSyAe9B2FhNok7R1NuAhc2UaZrjfvdWU9-W0',
  authDomain: 'emerald-road-216311.firebaseapp.com',
  databaseURL: 'https://emerald-road-216311.firebaseio.com',
  projectId: 'emerald-road-216311',
  storageBucket: 'emerald-road-216311.appspot.com',
  messagingSenderId: '1068042055502',
  appId: '1:1068042055502:web:b7025902ee4a084a7ef81f',
};

const firebaseApp = initializeApp(config);

export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);
export const database = getDatabase(firebaseApp);
